// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://basescan.org/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://basescan.org/address/0xc85b1E333aecc99340b2320493Fe2d22b8734795
export const PROXY_ADMIN = '0xc85b1E333aecc99340b2320493Fe2d22b8734795';

// https://basescan.org/address/0x3b56998Ec06477704622ca8e2eA1b4db134cec32
export const CREATE_3_FACTORY = '0x3b56998Ec06477704622ca8e2eA1b4db134cec32';

// https://basescan.org/address/0x88db99eeBb390a2a4DcAC2E1DDb09c07E911C5C3
export const AAVE_CL_ROBOT_OPERATOR = '0x88db99eeBb390a2a4DcAC2E1DDb09c07E911C5C3';

// https://basescan.org/address/0x56C1a4b54921DEA9A344967a8693C7E661D72968
export const PROTOCOL_GUARDIAN = '0x56C1a4b54921DEA9A344967a8693C7E661D72968';

// https://basescan.org/address/0xB88BAc61a4Ca37C43a3725912B1f472c9A5bc061
export const wstETH_stETH_AGGREGATOR = '0xB88BAc61a4Ca37C43a3725912B1f472c9A5bc061';

// https://basescan.org/address/0x868a501e68F3D1E89CfC0D22F6b22E8dabce5F04
export const cbETH_ETH_AGGREGATOR = '0x868a501e68F3D1E89CfC0D22F6b22E8dabce5F04';

// https://basescan.org/address/0xA9F30e6ED4098e9439B2ac8aEA2d3fc26BcEbb45
export const LEGACY_BRIDGE_EXECUTOR = '0xA9F30e6ED4098e9439B2ac8aEA2d3fc26BcEbb45';

// https://basescan.org/address/0x22740deBa78d5a0c24C58C740e3715ec29de1bFa
export const AFC_SAFE = '0x22740deBa78d5a0c24C58C740e3715ec29de1bFa';

// https://basescan.org/address/0xA1c93D2687f7014Aaf588c764E3Ce80aF016229b
export const ALC_SAFE = '0xA1c93D2687f7014Aaf588c764E3Ce80aF016229b';

// https://basescan.org/address/0xdef1FA4CEfe67365ba046a7C630D6B885298E210
export const MASIV_SAFE = '0xdef1FA4CEfe67365ba046a7C630D6B885298E210';

// https://basescan.org/address/0xAA43203167317DeeF8288095C44b84a686918d2E
export const APE_SAFE = '0xAA43203167317DeeF8288095C44b84a686918d2E';

// https://basescan.org/address/0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6
export const APE_VOTING_SAFE = '0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6';

// https://basescan.org/address/0xAAB6f926DCDaE536F54ce58478Dbc1a0d0f98871
export const ALC_INCENTIVE_SAFE = '0xAAB6f926DCDaE536F54ce58478Dbc1a0d0f98871';

// https://basescan.org/address/0xAA870e4B82deaDa3727235f34183Ec9B728714C8
export const MERIT_INCENTIVE_SAFE = '0xAA870e4B82deaDa3727235f34183Ec9B728714C8';

// https://basescan.org/address/0xAA2461f0f0A3dE5fEAF3273eAe16DEF861cf594e
export const AHAB_SAFE = '0xAA2461f0f0A3dE5fEAF3273eAe16DEF861cf594e';

// https://basescan.org/address/0x115E662Fa3f0b83014eB3f6F86F3D94BeC5eB411
export const AGENT_HUB = '0x115E662Fa3f0b83014eB3f6F86F3D94BeC5eB411';

// https://basescan.org/address/0x78C2eCf3Ad48F90350f42EB338675cA1b31a7f11
export const AGENT_HUB_AUTOMATION = '0x78C2eCf3Ad48F90350f42EB338675cA1b31a7f11';

// https://basescan.org/address/0x9240a6669CC4782FC98620212862DF5CB2e0Df10
export const RANGE_VALIDATION_MODULE = '0x9240a6669CC4782FC98620212862DF5CB2e0Df10';

export const CHAIN_ID = 8453;
